import { AUTH_TYPES } from '@/constant'

/**
 * @description Check if fields required are present or not.
 * @param {Object} cmsApp CMS App object
 * @param {Object} appCredentials App credentials object
 * @returns {Boolean} True if fields are present & valid, false otherwise.
 */
const checkFieldsRequired = (cmsApp, appCredentials) => {
  return cmsApp.attributes.fieldsRequired.every((field) => {
    if (field.required === false) return true
    return appCredentials[field.key] != null && appCredentials[field.key] !== ''
  })
}

/**
 * @description Check for values of the oauth app credentials.
 * @param {Object} cmsApps CMS App object
 * @param {Object} appCredentials App credentials object
 * @returns {Boolean} True if fields are present, valid & oAuth2 object is present, false otherwise.
 */
const oauthValidityChecker = (cmsApps, appCredentials) => {
  return checkFieldsRequired(cmsApps, appCredentials) && appCredentials.oAuth2 != null
}

/**
 * @description Check if the app credentials are valid or not.
 * @param {Object} cmsApps CMS App object
 * @param {Object} appCredentials App credentials object
 * @returns {Boolean} True if credentials are valid, false otherwise.
 */
export const credentialsValidity = (cmsApp, appCredentials) => {
  if (cmsApp.attributes.authType === AUTH_TYPES.OAUTH2) {
    return oauthValidityChecker(cmsApp, appCredentials)
  } else if (cmsApp.attributes.authType === AUTH_TYPES.CREDENTIALS || cmsApp.attributes.authType === AUTH_TYPES.CUSTOM) {
    return checkFieldsRequired(cmsApp, appCredentials)
  }
  return false
}
